exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width: 768px) {\n.scrollbar[data-v-7bac194e] {\n      height: 165%;\n}\n}\n@media (min-width: 1200px) {\n.item-inner[data-v-7bac194e] {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7bac194e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/bankAccounts/CMBankAccountsPage/CMBankAccountsList.vue
// module id = 1588
// module chunks = 2